import React from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  Divider
} from '@material-ui/core';
import cx from 'classnames';
import Typography from 'components/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles(theme => ({
  cardContainerSquare: {
    width: '100%',
    minHeight: 110,
    borderRadius: 12
  },
  cardContainerSquare2: {
    width: 'calc(100% - 20px)',
    padding: 10,
    height: 'calc(100% - 20px)',
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  cardContainerSquare3: {
    width: '100%',
    height: '100%',
    borderRadius: 8,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  cardContainerRectangle: {
    width: '100%',
    height: 64,
    borderRadius: 12,
    display: 'flex'
  },
  leftCardSquare: {
    width: '75%',
    paddingTop: 30,
    paddingLeft: 25
  },
  topCardSquare2: {
    width: '100%',
    display: 'flex'
  },
  leftCardRectangle: {
    width: '75%',
    paddingTop: 10,
    paddingLeft: 25
  },
  rightCard: {
    width: '25%',
    paddingTop: 20,
    paddingRight: 25,
    textAlign: 'right'
  },
  iconCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },

  bottomCardSquare2: {
    width: '100%',
    textAlign: 'center'
  },
  rightCardSquare3: {
    width: 'calc(98% - 20px)',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '0px 8px 8px 0px',
    padding: 10
  },
  iconContainer: {
    width: 18,
    height: 18,
    padding: 1,
    backgroundColor: '#ffffff47',
    borderRadius: 5,
    marginRight: 5,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }
}));

const Card = props => {
  const {
    children,
    style = {},
    variant = 'square', // square, rectangle, square2, square3
    value,
    title,
    subTitle,
    icon,
    iconCenter,
    color, // background image
    withAnimation = true,
    colorImage = true,
    customComponent,
    onClick
  } = props;
  const classes = useStyles();

  return (
    <div
      className={cx({
        zoomIn: withAnimation,
        [classes.cardContainerSquare]: (variant === 'square'),
        [classes.cardContainerSquare2]: (variant === 'square2'),
        [classes.cardContainerSquare3]: (variant === 'square3'),
        [classes.cardContainerRectangle]: (variant === 'rectangle')
      })}
      style={{
        ...style,
        cursor: onClick ? 'pointer' : 'default',
        backgroundImage: colorImage ? color || 'linear-gradient(108deg, #67b8eb 33%, #a5d5f3 88%)' : 'unset',
        backgroundColor: !colorImage ? color || '#3f66df' : 'unset'
      }}
      onClick={onClick && onClick}
    >
      {variant !== 'square3' &&
                <div className={cx({
                  [classes.topCardSquare2]: (variant === 'square2') || (variant === 'square'),
                  [classes.leftCardRectangle]: (variant === 'rectangle')
                })}>
                  {variant === 'square'
                    ? <div style={{ display: 'flex', width: '100%' }}>
                      <div className={classes.leftCardSquare}>
                        <Typography variant='h3' type='bold' color='#FFFFFF'>{value}</Typography>
                        <Typography variant='body1' color='#FFFFFF'>{title}</Typography>
                      </div>
                      <div className={`${classes.rightCard} ${iconCenter && classes.iconCenter}`}>
                        {children}
                        <FontAwesomeIcon icon={icon} size="2x" color="#FFFFFF" />
                      </div>
                    </div>
                    : variant === 'rectangle'
                      ? <>
                        <Typography variant='h6' color='#FFFFFF'>{title}</Typography>
                        <Typography variant='body1' color='#FFFFFF'>{subTitle}</Typography>
                      </>
                      : variant === 'square2'
                        ? <> <div>
                          <div className={classes.iconContainer}>
                            {icon
                              ? <FontAwesomeIcon icon={icon} size="xs" color="#FFFFFF" />
                              : children
                            }
                          </div>
                          <Divider width={30} style={{ marginTop: 5, backgroundColor: '#ffffff47' }}/>
                        </div>
                        <Typography variant='caption' color='#FFFFFF' className={classes.title}>
                          {title}
                        </Typography>
                        </>
                        : <> </>
                  }
                </div>
      }
      <div className={cx({
        [classes.rightCard]: (variant === 'rectangle'),
        [classes.bottomCardSquare2]: (variant === 'square2') || (variant === 'square'),
        [classes.rightCardSquare3]: (variant === 'square3')
      })}>
        {variant === 'square'
          ? <>
            {customComponent && customComponent}
          </>
          : variant === 'rectangle'
            ? <Typography variant='h3' type='bold' color='#FFFFFF'>{value}</Typography>
            : variant === 'square2'
              ? <>
                {/* <div style={{textAlign: 'end'}}>
                            <FontAwesomeIcon icon='chevron-right' size="md" color='#ffffff47' />
                        </div> */}
                <Typography variant='caption' color='#FFFFFF' style={{ marginTop: 15 }}>{value}</Typography>
              </>
              : <>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant='body1' type='bold' color={color}>
                    {title}
                  </Typography>
                  <Typography variant='body1'>
                    {subTitle}
                  </Typography>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ marginTop: 10, flexGrow: 1, marginRight: 10, width: 'calc(100% - 40px)' }}>
                    {value}
                  </div>
                  <div style={{
                    width: 40,
                    height: 40,
                    backgroundColor: color,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '50%'
                  }}>
                    <FontAwesomeIcon icon={icon} size="lg" color="#FFFFFF" />
                  </div>
                </div>
              </>
        }
      </div>
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.any,
  className: PropTypes.object,
  style: PropTypes.object,
  // Style bentuk card
  variant: PropTypes.oneOf(['rectangle', 'square', 'square2', 'square3']),
  // Nilai yang ingin ditampilkan di Card
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  // Judul yang ditampilkan pada card
  title: PropTypes.string,
  // Sub Judul yang ditampilkan pada card
  subTitle: PropTypes.string,
  // Icon yang akan ditampilkan pada Card
  icon: PropTypes.string,
  // Warna Card
  color: PropTypes.string,
  // Animasi pada saat rendering card pertama kali
  withAnimation: PropTypes.bool,
  // Jika true Color akan menggunakan Background Image jika false maka menggunakan Backgroun Color
  colorImage: PropTypes.bool,
  // Komponen Custom ketika variant = square
  customComponent: PropTypes.any
};

export default Card;
